import api from "./api";

export async function bravoRequest(data) {
  try {
    await api.post('https://manager.bravohub.app/api/ci/external-gamification/29af6c9d-2c40-407d-8616-14c93f3f2dc1', data)
  } catch (error) {
    console.error('Erro ao enviar requisição para o Bravo:', error);
  }
}